import React from 'react';
import { QrCode } from 'lucide-react';

/**
 * Shown on pay domain root (/) when customer has not scanned a mesa QR.
 * No navigation to admin; customer stays in payment app.
 */
const PayLanding: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <QrCode className="w-10 h-10 text-gray-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          YAP — Pago en mesa
        </h1>
        <p className="text-gray-600">
          Escanee el código QR de su mesa para ver la cuenta y pagar.
        </p>
        <p className="text-gray-500 text-sm mt-4">
          No cierre esta página. Use el QR del restaurante.
        </p>
      </div>
    </div>
  );
};

export default PayLanding;
